import { authFetch, cachedTenantConfig } from './auth';
import { APP_CONFIG } from './config';

// Parse config_json which uses PHP array syntax (=> instead of :)
const parseConfigJson = (str) => {
  if (!str) return {};
  try {
    const json = str
      .replace(/=>/g, ':')       // PHP array syntax → JSON
      .replace(/[\r\n]+/g, ' '); // literal newlines inside string values break JSON.parse
    return JSON.parse(json);
  } catch {
    return {};
  }
};

const processConfig = (config) => {
  const extra = parseConfigJson(config.config_json);
  return {
    ...config,
    color:       extra.color                             ?? null,
    description: extra.descripiton ?? extra.description ?? null,
    site_name:   extra.site_name                        ?? null,
    base_url:    extra.Base_Url                         ?? null,
    app_status:  extra.app_status                       ?? null,
  };
};

export const fetchTenantConfig = async () => {
  // Use config already returned by get-token.php (no extra network call)
  if (cachedTenantConfig) return processConfig(cachedTenantConfig);

  let res;
  try {
    res = await authFetch(APP_CONFIG.TENANT_CONFIG_URL, {
      method: 'GET',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    });
  } catch (error) {
    throw new Error(`TENANT_CONFIG_NETWORK_ERROR: ${error.message}`);
  }

  if (!res.ok) throw new Error(`TENANT_CONFIG_FETCH_FAILED_${res.status}`);

  let data;
  try { data = await res.json(); } catch { throw new Error('TENANT_CONFIG_PARSE_FAILED'); }

  const config = Array.isArray(data) ? data[0] : data?.items?.[0] ?? data ?? null;
  if (!config) throw new Error('TENANT_CONFIG_EMPTY');

  return processConfig(config);
};
